import {compareStrings, displayTranslations, parseCategoryName, parseLanguage, titleize} from "../../utils/utils";
import GameNameParser from "./GameNameParser";
import React, { useState } from "react";
import ExpansionIcon from "./ExpansionIcon";
import I18n from "i18n-js";
import LanguageFlag from "./LanguageFlag";

const  BlueprintImageAccordionContent = ({
    blueprintImage,
    hideGame
  }) => {
  
  const eraNames = displayTranslations(blueprintImage.en_era_name, blueprintImage.era_name, blueprintImage.language)
  const expansionNames = displayTranslations(blueprintImage.en_expansion_name, blueprintImage.expansion_name, blueprintImage.language)


  return (
    <React.Fragment>
      <div className="row">
        <div className="col-xs-3 col-md-2">
          <p
            className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.cardLanguage")}:</p>
        </div>

        <div className="col-xs-9 col-md-4">
          <div className="d-flex justify-content-end align-items-center pr-20px text-right pl-md-2 mb-0">
            <span className="mr-2">
              { parseLanguage(blueprintImage.language_filter) }
            </span>
            <LanguageFlag
              language={blueprintImage.language}
              maxHeight={'15px'}
              containerCssClassList={'d-flex justify-content-end'}
            />
          </div>
        </div>

        {
          (blueprintImage.version || (blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity'))) &&
            <React.Fragment>
              {
                blueprintImage.version &&
                <React.Fragment>
                  <div className="col-xs-3 col-md-2">
                    <p
                      className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.version")}:</p>
                  </div>

                  <div className="col-xs-9 col-md-4">
                    <p
                      className="pr-20px text-right pl-md-2 mb-0 text-capitalize">{blueprintImage.version}</p>
                  </div>
                </React.Fragment>
              }

              {
                blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') &&
                <React.Fragment>
                  <div className="col-xs-3 col-md-2">
                    <p
                      className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.rarity")}:</p>
                  </div>

                  <div className="col-xs-9 col-md-4">
                    <p
                      className="pr-20px text-right pl-md-2 mb-0 text-capitalize">{blueprintImage.rarity}
                      {
                        blueprintImage.rarity_logo_url &&
                        <img src={blueprintImage.rarity_logo_url} alt=""
                             className="ml-1 mb-1" style={{ maxWidth: "15px" }} />
                      }
                    </p>
                  </div>
                </React.Fragment>
              }
            </React.Fragment>
        }

        {
          ((blueprintImage.edition && blueprintImage.edition !== "Undefined") || blueprintImage.print_sheet_code) &&
          <React.Fragment>
            {
              blueprintImage.edition && blueprintImage.edition !== "Undefined" &&
              <React.Fragment>
                <div className="col-xs-3 col-md-2">
                  <p
                    className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.edition")}:</p>
                </div>

                <div className="col-xs-9 col-md-4">
                  <p className="pr-20px text-right pl-md-2 mb-0 text-capitalize">
                    {blueprintImage.edition}
                  </p>
                </div>
              </React.Fragment>
            }

            {
              blueprintImage.print_sheet_code &&
              <React.Fragment>
                <div className="col-xs-3 col-md-2">
                  <p
                    className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.common.sheetCode")}:</p>
                </div>

                <div className="col-xs-9 col-md-4">
                  <p
                    className="pr-20px text-right pl-md-2 mb-0 text-capitalize">{blueprintImage.print_sheet_code}
                  </p>
                </div>
              </React.Fragment>
            }
          </React.Fragment>
        }

        {
          !hideGame &&
            <React.Fragment>
              <div className="col-xs-3 col-md-2">
                <p className="pl-20px text-weight-500 text--white-space-no-wrap">
                  {I18n.t("js.myCollectionEditPage.tableHeaderGame")}
                </p>
              </div>

              <div className="col-xs-9 col-md-4 text-right">
                <GameNameParser
                  game_name={blueprintImage.game.name}
                  additionalClasses1={"pr-20px text-right text-md-right pl-md-2 mb-0"}
                />
              </div>
            </React.Fragment>
        }


        <div className="col-xs-3 col-md-2">
          <p
            className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.category")}:</p>
        </div>

        <div className="col-xs-9 col-md-4">
          <p className="pr-20px text-right pl-md-2 mb-0">
            {parseCategoryName(blueprintImage.blueprint.category.name)}
          </p>
        </div>

        {
          (blueprintImage.en_era_name || blueprintImage.era_name) &&
          <React.Fragment>
            <div className="col-xs-3 col-md-2">
              <p
                className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.era")}:</p>
            </div>

            <div className="col-xs-9 col-md-4">
              {
                eraNames.length > 1 ?
                  <React.Fragment>
                    <p
                      className="pr-20px text-right pl-md-2 mb-0">
                      { eraNames[0] }
                    </p>
                    <p
                      className="pr-20px text-right pl-md-2 text--size-small">
                      ({ eraNames[1] })
                    </p>
                  </React.Fragment>
                  :
                  <p
                    className="pr-20px text-right pl-md-2 mb-0">
                    { eraNames[0] }
                  </p>
              }
            </div>
          </React.Fragment>
        }

        {
          (blueprintImage.en_expansion_name || blueprintImage.expansion_name) &&
          <React.Fragment>
            <div className="col-xs-4 col-md-2">
              <p
                className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.expansion")}:</p>
            </div>

            <div className="col-xs-8 col-md-4">
              {
                expansionNames.length > 1 ?
                  <React.Fragment>
                    <p
                      className="pr-20px text-right pl-md-2 mb-0">
                      { expansionNames[0] }
                    </p>
                    <p
                      className="pr-20px text-right pl-md-2 text--size-small">
                      ({ expansionNames[1] })
                    </p>
                  </React.Fragment>
                  :
                  <p
                    className="pr-20px text-right pl-md-2 ">
                    { expansionNames[0] }
                  </p>
              }

              {
                blueprintImage.expansion.icon_url &&
                  <div className="text-right pr-20px mb-2"
                       key={blueprintImage.expansion.icon_url}>
                    <ExpansionIcon
                      icon_url={blueprintImage.expansion.icon_url}
                      width={"25px"}
                    />
                  </div>
              }
            </div>
          </React.Fragment>
        }

      </div>
    </React.Fragment>
  );
}

export default  BlueprintImageAccordionContent;
